import React, { useState, useEffect, useRef } from "react";
import { FaWhatsapp } from "react-icons/fa";

const FloatingWhatsappButton = () => {
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);

  const numbers = [
    {
      label: "+971 58 571 9601",
      number: "971585719601",
      message: "Hello! I am interested in your services.",
    },
  ];

  const getLink = (num, msg) =>
    `https://wa.me/${num}?text=${encodeURIComponent(msg)}`;

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
  <div
    className="fixed bottom-5 left-5 z-50 flex flex-col items-start"
    ref={menuRef}
  >
    {/* Main Floating Button */}
    <button
      onClick={() => setOpen(!open)}
      className="bg-green-600 hover:bg-green-700 text-white p-4 rounded-full shadow-lg flex items-center justify-center transition duration-300"
      aria-label="Chat on WhatsApp"
    >
      <FaWhatsapp size={24} />
    </button>

    {/* Dropdown - absolutely positioned */}
    {open && (
      <div className="absolute bottom-16 w-56 bg-white rounded-xl shadow-xl border border-gray-100 overflow-hidden animate-fade-in-down">
        {numbers.map((item, idx) => (
          <a
            key={idx}
            href={getLink(item.number, item.message)}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 px-4 py-3 text-sm font-medium text-gray-700 hover:bg-green-50 hover:text-green-700 transition-colors duration-200"
          >
            <FaWhatsapp className="text-green-600" /> {item.label}
          </a>
        ))}
      </div>
    )}
  </div>
);

};

export default FloatingWhatsappButton;
